import React from 'react'

const HeroAsset = (props) => {
  return (
    <svg
      width="445"
      height="529"
      viewBox="0 0 445 529"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      {...props}
    >
      <rect x="299" width="146" height="161" fill="#393E42" />
      <line
        x1="322"
        y1="20.8731"
        x2="424"
        y2="20.8731"
        stroke="#D4D7D9"
        strokeWidth="2.25375"
      />
      <line
        x1="322"
        y1="32.5177"
        x2="372.354"
        y2="32.5177"
        stroke="#5CEBA0"
        strokeWidth="2.25375"
      />
      <line
        x1="378.811"
        y1="32.5177"
        x2="402.051"
        y2="32.5177"
        stroke="#FCE969"
        strokeWidth="2.25375"
      />
      <line
        x1="322"
        y1="44.1622"
        x2="412.38"
        y2="44.1622"
        stroke="#D4D7D9"
        strokeWidth="2.25375"
      />
      <line
        x1="322"
        y1="67.4508"
        x2="363.316"
        y2="67.4508"
        stroke="#FCE969"
        strokeWidth="2.25375"
      />
      <line
        x1="369.771"
        y1="67.4508"
        x2="400.759"
        y2="67.4508"
        stroke="#5CEBA0"
        strokeWidth="2.25375"
      />
      <line
        x1="322"
        y1="79.0948"
        x2="389.139"
        y2="79.0948"
        stroke="#FD7A7D"
        strokeWidth="2.25375"
      />
      <line
        x1="322"
        y1="55.8062"
        x2="393.013"
        y2="55.8062"
        stroke="#D4D7D9"
        strokeWidth="2.25375"
      />
      <line
        x1="322"
        y1="91.4234"
        x2="368.481"
        y2="91.4234"
        stroke="#D4D7D9"
        strokeWidth="2.25375"
      />
      <line
        x1="322"
        y1="102.812"
        x2="347.823"
        y2="102.812"
        stroke="#5CEBA0"
        strokeWidth="2.25375"
      />
      <line
        y1="-1.12688"
        x2="102"
        y2="-1.12688"
        transform="matrix(1 -9.87336e-08 -7.74078e-08 -1 300 137)"
        stroke="#B3B9BD"
        strokeWidth="2.25375"
      />
      <line
        y1="-1.12688"
        x2="50.3544"
        y2="-1.12688"
        transform="matrix(1 0 0 -1 322 125.355)"
        stroke="#5CEBA0"
        strokeWidth="2.25375"
      />
      <line
        y1="-1.12688"
        x2="23.2405"
        y2="-1.12688"
        transform="matrix(1 0 0 -1 370 125.355)"
        stroke="#FCE969"
        strokeWidth="2.25375"
      />
      <line
        y1="-1.12688"
        x2="90.3798"
        y2="-1.12688"
        transform="matrix(1 0 0 -1 322 113.711)"
        stroke="#B3B9BD"
        strokeWidth="2.25375"
      />
      <line
        y1="-1.12688"
        x2="41.3165"
        y2="-1.12688"
        transform="matrix(1 0 0 -1 322 90.4224)"
        stroke="#FCE969"
        strokeWidth="2.25375"
      />
      <line
        y1="-1.12688"
        x2="30.9873"
        y2="-1.12688"
        transform="matrix(1 0 0 -1 369.771 90.4224)"
        stroke="#5CEBA0"
        strokeWidth="2.25375"
      />
      <line
        y1="-1.12688"
        x2="71.0127"
        y2="-1.12688"
        transform="matrix(1 0 0 -1 322 102.067)"
        stroke="#B3B9BD"
        strokeWidth="2.25375"
      />
      <path d="M63 73H370V471H63V73Z" fill="#61C9D7" />
      <g filter="url(#filter0_d_6595_7250)">
        <rect
          x="204.043"
          y="34"
          width="32.3704"
          height="58.9141"
          fill="#0FAE5C"
        />
      </g>
      <g filter="url(#filter1_d_6595_7250)">
        <rect
          x="264.25"
          y="61.8389"
          width="32.3704"
          height="88.0475"
          transform="rotate(90 264.25 61.8389)"
          fill="#0FAE5C"
        />
      </g>
      <g filter="url(#filter2_d_6595_7250)">
        <ellipse
          cx="228.405"
          cy="86.3655"
          rx="2.26645"
          ry="2.30243"
          transform="rotate(-180 228.405 86.3655)"
          fill="white"
        />
      </g>
      <g filter="url(#filter3_d_6595_7250)">
        <ellipse
          cx="228.405"
          cy="78.6922"
          rx="2.26645"
          ry="2.30243"
          transform="rotate(-180 228.405 78.6922)"
          fill="white"
        />
      </g>
      <g filter="url(#filter4_d_6595_7250)">
        <ellipse
          cx="228.405"
          cy="71.0164"
          rx="2.26645"
          ry="2.30243"
          transform="rotate(-180 228.405 71.0164)"
          fill="white"
        />
      </g>
      <g filter="url(#filter5_d_6595_7250)">
        <ellipse
          cx="220.347"
          cy="86.366"
          rx="2.26645"
          ry="2.30243"
          transform="rotate(-180 220.347 86.366)"
          fill="white"
        />
      </g>
      <g filter="url(#filter6_d_6595_7250)">
        <ellipse
          cx="220.347"
          cy="78.6922"
          rx="2.26645"
          ry="2.30243"
          transform="rotate(-180 220.347 78.6922)"
          fill="white"
        />
      </g>
      <g filter="url(#filter7_d_6595_7250)">
        <ellipse
          cx="220.347"
          cy="71.0164"
          rx="2.26645"
          ry="2.30243"
          transform="rotate(-180 220.347 71.0164)"
          fill="white"
        />
      </g>
      <g filter="url(#filter8_d_6595_7250)">
        <ellipse
          cx="212.288"
          cy="86.366"
          rx="2.26645"
          ry="2.30243"
          transform="rotate(-180 212.288 86.366)"
          fill="white"
        />
      </g>
      <g filter="url(#filter9_d_6595_7250)">
        <ellipse
          cx="212.288"
          cy="78.6922"
          rx="2.26645"
          ry="2.30243"
          transform="rotate(-180 212.288 78.6922)"
          fill="white"
        />
      </g>
      <g filter="url(#filter10_d_6595_7250)">
        <ellipse
          cx="212.288"
          cy="71.0164"
          rx="2.26645"
          ry="2.30243"
          transform="rotate(-180 212.288 71.0164)"
          fill="white"
        />
      </g>
      <g filter="url(#filter11_d_6595_7250)">
        <path
          d="M328.832 107L316.841 94.2085H86.334V450.347H349V128.5L328.832 107Z"
          fill="white"
        />
      </g>
      <path d="M299 94L349 144L349 94L299 94Z" fill="#DFF4F7" />
      <rect x="118" y="171" width="118" height="7" fill="#D4D7D9" />
      <rect x="259" y="171" width="59" height="7" fill="#D4D7D9" />
      <rect x="244" y="235" width="74" height="7" fill="#D4D7D9" />
      <rect
        x="117.973"
        y="147"
        width="92.0476"
        height="8.03589"
        fill="#D4D7D9"
      />
      <rect
        x="145.934"
        y="275.649"
        width="12.0614"
        height="12.0614"
        stroke="#D4D7D9"
        strokeWidth="1.86735"
      />
      <rect x="169" y="279" width="149" height="7" fill="#D4D7D9" />
      <rect
        x="145.934"
        y="349.936"
        width="12.0614"
        height="12.0614"
        stroke="#D4D7D9"
        strokeWidth="1.86735"
      />
      <rect x="169" y="352" width="149" height="7" fill="#D4D7D9" />
      <rect x="118" y="219" width="200" height="7" fill="#D4D7D9" />
      <rect
        x="145.934"
        y="325.174"
        width="12.0614"
        height="12.0614"
        stroke="#D4D7D9"
        strokeWidth="1.86735"
      />
      <rect x="169" y="328" width="149" height="7" fill="#D4D7D9" />
      <rect x="118" y="203" width="86" height="7" fill="#D4D7D9" />
      <rect x="213" y="203" width="105" height="7" fill="#D4D7D9" />
      <rect x="118" y="187" width="200" height="7" fill="#D4D7D9" />
      <rect
        x="145.934"
        y="300.412"
        width="12.0614"
        height="12.0614"
        stroke="#D4D7D9"
        strokeWidth="1.86735"
      />
      <rect x="169" y="303" width="149" height="7" fill="#D4D7D9" />
      <rect
        x="145.934"
        y="374.698"
        width="12.0614"
        height="12.0614"
        stroke="#D4D7D9"
        strokeWidth="1.86735"
      />
      <rect x="169" y="377" width="127" height="7" fill="#D4D7D9" />
      <rect
        width="173"
        height="1"
        transform="matrix(1 -2.7429e-10 -1.68514e-07 -1 145 413)"
        fill="#D4D7D9"
      />
      <g clipPath="url(#clip0_6595_7250)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M154.236 382.582L160.493 376.325L158.725 374.558L152.469 380.814L149.795 378.14L148.027 379.907L150.702 382.582L150.701 382.582L152.469 384.349L152.469 384.349L152.47 384.349L154.237 382.582L154.236 382.582Z"
          fill="#1D1F21"
        />
      </g>
      <g clipPath="url(#clip1_6595_7250)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M154.236 332.582L160.493 326.325L158.725 324.558L152.469 330.814L149.795 328.14L148.027 329.907L150.702 332.582L150.701 332.582L152.469 334.349L152.469 334.349L152.47 334.349L154.237 332.582L154.236 332.582Z"
          fill="#1D1F21"
        />
      </g>
      <g clipPath="url(#clip2_6595_7250)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M154.236 357.582L160.493 351.325L158.725 349.558L152.469 355.814L149.795 353.14L148.027 354.907L150.702 357.582L150.701 357.582L152.469 359.349L152.469 359.349L152.47 359.349L154.237 357.582L154.236 357.582Z"
          fill="#1D1F21"
        />
      </g>
      <g clipPath="url(#clip3_6595_7250)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M154.236 283.582L160.493 277.325L158.725 275.558L152.469 281.814L149.795 279.14L148.027 280.907L150.702 283.582L150.701 283.582L152.469 285.349L152.469 285.349L152.47 285.349L154.237 283.582L154.236 283.582Z"
          fill="#1D1F21"
        />
      </g>
      <g clipPath="url(#clip4_6595_7250)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M154.236 308.582L160.493 302.325L158.725 300.558L152.469 306.814L149.795 304.14L148.027 305.907L150.702 308.582L150.701 308.582L152.469 310.349L152.469 310.349L152.47 310.349L154.237 308.582L154.236 308.582Z"
          fill="#1D1F21"
        />
      </g>
      <rect x="118" y="235" width="118" height="7" fill="#D4D7D9" />
      <g mixBlendMode="multiply">
        <rect
          x="112.773"
          y="167.774"
          width="131.531"
          height="13.7895"
          fill="#ABF6CF"
        />
        <rect
          x="112.773"
          y="167.774"
          width="131.531"
          height="13.7895"
          stroke="#1D1F21"
          strokeWidth="1.06073"
        />
      </g>
      <rect
        x="243.773"
        y="181.033"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="243.773"
        y="163"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect
        x="108"
        y="181.033"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect x="108" y="163" width="4.61512" height="4.61512" fill="#1D1F21" />
      <g mixBlendMode="multiply">
        <rect
          x="240.53"
          y="231.53"
          width="81.9393"
          height="13.9393"
          fill="#ABF6CF"
        />
        <rect
          x="240.53"
          y="231.53"
          width="81.9393"
          height="13.9393"
          stroke="#1D1F21"
          strokeWidth="1.06073"
        />
      </g>
      <rect
        x="322"
        y="245.033"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect x="322" y="227" width="4.61512" height="4.61512" fill="#1D1F21" />
      <rect
        x="236"
        y="245.033"
        width="4.61512"
        height="4.61512"
        fill="#1D1F21"
      />
      <rect x="236" y="227" width="4.61512" height="4.61512" fill="#1D1F21" />
      <g clipPath="url(#clip5_6595_7250)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.9563 62.11H74.8376V59.7963C74.8376 55.9631 71.7301 52.8556 67.8969 52.8556C64.0637 52.8556 60.9563 55.9631 60.9563 59.7963V62.11ZM56.3292 62.11H49.3887V94.4997H86.4055V62.11H79.4647V59.7963C79.4647 53.4076 74.2856 48.2285 67.8969 48.2285C61.5082 48.2285 56.3292 53.4076 56.3292 59.7963V62.11Z"
          fill="#1D1F21"
        />
        <ellipse
          cx="67.8977"
          cy="74.6731"
          rx="3.09693"
          ry="3.09693"
          fill="#B0E4EB"
        />
        <path
          d="M70.9946 83.9646H64.8008L68.1042 72.3511L70.9946 83.9646Z"
          fill="#B0E4EB"
        />
        <rect
          x="38"
          y="74.1133"
          width="23.4915"
          height="7.47455"
          fill="#FD7A7D"
        />
        <circle cx="41.7365" cy="77.8502" r="1.60169" fill="#FD7A7D" />
        <circle cx="47.0763" cy="77.8502" r="1.60169" fill="#FD7A7D" />
        <circle cx="52.4142" cy="77.8502" r="1.60169" fill="#FD7A7D" />
        <circle cx="57.754" cy="77.8502" r="1.60169" fill="#FD7A7D" />
        <circle cx="41.7365" cy="77.9518" r="1.60169" fill="#1D1F21" />
        <circle cx="47.0763" cy="77.9518" r="1.60169" fill="#1D1F21" />
        <circle cx="52.4142" cy="77.9518" r="1.60169" fill="#1D1F21" />
        <circle cx="57.754" cy="77.9518" r="1.60169" fill="#1D1F21" />
        <path
          d="M70.9929 39.1381C71.1183 38.752 71.6645 38.752 71.7899 39.1381L72.3218 40.7757C72.3779 40.9484 72.5388 41.0653 72.7204 41.0653L74.442 41.0653C74.8479 41.0653 75.0167 41.5846 74.6884 41.8233L73.2953 42.8357C73.1485 42.9424 73.087 43.1315 73.1431 43.3041L73.6752 44.9422C73.8006 45.3282 73.3587 45.6492 73.0303 45.4106L71.6377 44.3985C71.4908 44.2917 71.2919 44.2917 71.145 44.3985L69.7525 45.4106C69.4241 45.6492 68.9822 45.3282 69.1076 44.9422L69.6397 43.3041C69.6957 43.1315 69.6343 42.9424 69.4875 42.8357L68.0944 41.8233C67.7661 41.5846 67.9349 41.0653 68.3407 41.0653L70.0624 41.0653C70.2439 41.0653 70.4048 40.9484 70.4609 40.7757L70.9929 39.1381Z"
          fill="#0FAE5C"
        />
        <path
          d="M82.0842 36.2856C82.2096 35.8995 82.7558 35.8995 82.8812 36.2856L83.4135 37.9237C83.4696 38.0963 83.6305 38.2132 83.812 38.2132L85.5344 38.2132C85.9403 38.2132 86.1091 38.7327 85.7807 38.9713L84.3872 39.9837C84.2404 40.0904 84.1789 40.2795 84.235 40.4521L84.7673 42.0903C84.8927 42.4763 84.4509 42.7973 84.1225 42.5587L82.729 41.5463C82.5821 41.4396 82.3833 41.4396 82.2364 41.5463L80.8429 42.5587C80.5145 42.7973 80.0727 42.4763 80.1981 42.0903L80.7304 40.4521C80.7865 40.2795 80.725 40.0904 80.5782 39.9837L79.1847 38.9713C78.8563 38.7327 79.0251 38.2132 79.431 38.2132L81.1534 38.2132C81.3349 38.2132 81.4958 38.0963 81.5519 37.9237L82.0842 36.2856Z"
          fill="#0FAE5C"
        />
        <path
          d="M93.1779 39.1376C93.3034 38.7516 93.8495 38.7516 93.975 39.1376L94.5072 40.7757C94.5633 40.9484 94.7242 41.0653 94.9057 41.0653L96.6282 41.0653C97.0341 41.0653 97.2028 41.5847 96.8744 41.8233L95.481 42.8357C95.3341 42.9424 95.2727 43.1315 95.3288 43.3042L95.861 44.9423C95.9865 45.3284 95.5446 45.6494 95.2162 45.4108L93.8227 44.3984C93.6759 44.2917 93.477 44.2917 93.3302 44.3984L91.9367 45.4108C91.6083 45.6494 91.1664 45.3284 91.2919 44.9423L91.8241 43.3042C91.8802 43.1315 91.8188 42.9424 91.6719 42.8357L90.2785 41.8233C89.9501 41.5847 90.1188 41.0653 90.5247 41.0653L92.2472 41.0653C92.4287 41.0653 92.5896 40.9484 92.6457 40.7757L93.1779 39.1376Z"
          fill="#0FAE5C"
        />
        <path
          d="M101.098 47.3764C101.223 46.9903 101.769 46.9904 101.895 47.3764L102.427 49.0145C102.483 49.1872 102.644 49.3041 102.826 49.3041L104.548 49.3041C104.954 49.3041 105.123 49.8235 104.794 50.0621L103.401 51.0745C103.254 51.1812 103.193 51.3703 103.249 51.543L103.781 53.1811C103.906 53.5671 103.465 53.8882 103.136 53.6496L101.743 52.6372C101.596 52.5304 101.397 52.5304 101.25 52.6372L99.8566 53.6496C99.5282 53.8882 99.0864 53.5671 99.2118 53.1811L99.7441 51.543C99.8002 51.3703 99.7387 51.1812 99.5918 51.0745L98.1984 50.0621C97.87 49.8235 98.0388 49.3041 98.4447 49.3041L100.167 49.3041C100.349 49.3041 100.51 49.1872 100.566 49.0145L101.098 47.3764Z"
          fill="#0FAE5C"
        />
        <path
          d="M104.268 58.4682C104.393 58.0821 104.939 58.0821 105.065 58.4682L105.597 60.1063C105.653 60.279 105.814 60.3959 105.996 60.3959L107.718 60.3959C108.124 60.3959 108.293 60.9153 107.964 61.1539L106.571 62.1663C106.424 62.273 106.363 62.4621 106.419 62.6348L106.951 64.2729C107.076 64.6589 106.634 64.98 106.306 64.7414L104.913 63.7289C104.766 63.6222 104.567 63.6222 104.42 63.7289L103.027 64.7414C102.698 64.98 102.256 64.6589 102.382 64.2729L102.914 62.6348C102.97 62.4621 102.909 62.273 102.762 62.1663L101.368 61.1539C101.04 60.9153 101.209 60.3959 101.615 60.3959L103.337 60.3959C103.519 60.3959 103.679 60.279 103.736 60.1063L104.268 58.4682Z"
          fill="#0FAE5C"
        />
        <path
          d="M101.098 69.559C101.223 69.173 101.769 69.173 101.895 69.559L102.427 71.1971C102.483 71.3698 102.644 71.4867 102.826 71.4867L104.548 71.4867C104.954 71.4867 105.123 72.0061 104.794 72.2447L103.401 73.2571C103.254 73.3638 103.193 73.5529 103.249 73.7256L103.781 75.3637C103.906 75.7498 103.465 76.0708 103.136 75.8322L101.743 74.8198C101.596 74.7131 101.397 74.7131 101.25 74.8198L99.8566 75.8322C99.5282 76.0708 99.0864 75.7498 99.2118 75.3637L99.7441 73.7256C99.8002 73.5529 99.7387 73.3638 99.5918 73.2571L98.1984 72.2447C97.87 72.0061 98.0388 71.4867 98.4447 71.4867L100.167 71.4867C100.349 71.4867 100.51 71.3698 100.566 71.1971L101.098 69.559Z"
          fill="#0FAE5C"
        />
        <path
          d="M93.1779 77.7983C93.3034 77.4122 93.8495 77.4122 93.975 77.7983L94.5072 79.4364C94.5633 79.609 94.7242 79.7259 94.9057 79.7259L96.6282 79.7259C97.0341 79.7259 97.2028 80.2454 96.8744 80.4839L95.481 81.4964C95.3341 81.6031 95.2727 81.7922 95.3288 81.9648L95.861 83.603C95.9865 83.989 95.5446 84.31 95.2162 84.0714L93.8227 83.059C93.6759 82.9523 93.477 82.9523 93.3302 83.059L91.9367 84.0714C91.6083 84.31 91.1664 83.989 91.2919 83.603L91.8241 81.9648C91.8802 81.7922 91.8188 81.6031 91.6719 81.4964L90.2785 80.4839C89.9501 80.2454 90.1188 79.7259 90.5247 79.7259L92.2472 79.7259C92.4287 79.7259 92.5896 79.609 92.6457 79.4364L93.1779 77.7983Z"
          fill="#0FAE5C"
        />
      </g>
      <g clipPath="url(#clip6_6595_7250)">
        <rect
          x="5.11914"
          y="272"
          width="116.048"
          height="251.585"
          rx="13.288"
          fill="#FAFAFA"
        />
        <path d="M5 507H121V524H5L5 507Z" fill="#61C9D7" />
        <rect x="14.5723" y="437" width="18" height="3" fill="#B3B9BD" />
        <rect
          x="15.0703"
          y="444.145"
          width="93.7874"
          height="13.1738"
          fill="white"
        />
        <rect
          x="15.0703"
          y="444.145"
          width="93.7874"
          height="13.1738"
          stroke="#D4D7D9"
        />
        <rect x="18" y="447.688" width="4.50704" height="6" fill="#5CEBA0" />
        <rect
          x="23.4082"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="28.8164"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="34.2246"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="39.6348"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="45.043"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="50.4512"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="55.8594"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="61.2676"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="66.6758"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="72.084"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="77.4922"
          y="447.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="15.3633"
          y="461.969"
          width="93.7874"
          height="13.4691"
          fill="white"
        />
        <rect
          x="15.3633"
          y="461.969"
          width="93.7874"
          height="13.4691"
          stroke="#D4D7D9"
        />
        <rect x="18" y="466" width="4.50704" height="6" fill="#5CEBA0" />
        <rect x="23.4082" y="466" width="4.50704" height="6" fill="#5CEBA0" />
        <rect x="28.8164" y="466" width="4.50704" height="6" fill="#5CEBA0" />
        <rect x="34.2246" y="466" width="4.50704" height="6" fill="#5CEBA0" />
        <rect x="39.6348" y="466" width="4.50704" height="6" fill="#5CEBA0" />
        <rect x="45.043" y="466" width="4.50704" height="6" fill="#5CEBA0" />
        <rect x="50.4512" y="466" width="4.50704" height="6" fill="#5CEBA0" />
        <rect x="55.8594" y="466" width="4.50704" height="6" fill="#5CEBA0" />
        <rect x="61.2676" y="466" width="4.50704" height="6" fill="#5CEBA0" />
        <rect
          x="15.0723"
          y="390.062"
          width="93.7874"
          height="13.1738"
          fill="white"
        />
        <rect
          x="15.0723"
          y="390.062"
          width="93.7874"
          height="13.1738"
          stroke="#D4D7D9"
        />
        <rect x="18" y="393.688" width="4.50704" height="6" fill="#5CEBA0" />
        <rect
          x="23.4082"
          y="393.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="28.8164"
          y="393.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="34.2246"
          y="393.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="39.6348"
          y="393.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="45.043"
          y="393.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="50.4512"
          y="393.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect x="14.5723" y="383" width="18" height="3" fill="#B3B9BD" />
        <rect
          x="15.0723"
          y="416.842"
          width="93.7874"
          height="13.1738"
          fill="white"
        />
        <rect
          x="15.0723"
          y="416.842"
          width="93.7874"
          height="13.1738"
          stroke="#D4D7D9"
        />
        <rect x="18" y="420.688" width="4.50704" height="6" fill="#5CEBA0" />
        <rect
          x="23.4082"
          y="420.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="28.8164"
          y="420.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="34.2246"
          y="420.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="39.6348"
          y="420.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="45.043"
          y="420.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="50.4512"
          y="420.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="55.8594"
          y="420.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect
          x="61.2676"
          y="420.688"
          width="4.50704"
          height="6"
          fill="#5CEBA0"
        />
        <rect x="14.5723" y="409.78" width="26" height="3" fill="#B3B9BD" />
        <rect
          x="14.8613"
          y="482.997"
          width="38.5045"
          height="12.9927"
          rx="6.49633"
          fill="#0185A2"
        />
        <rect x="25.1133" y="487.494" width="18" height="4" fill="#1D1F21" />
        <path
          d="M14.6973 313.789C14.6973 311.144 16.8413 309 19.4861 309H104.727C107.371 309 109.515 311.144 109.515 313.789V366.52C109.515 369.165 107.371 371.309 104.727 371.309H19.486C16.8413 371.309 14.6973 369.165 14.6973 366.52V313.789Z"
          fill="#B0E4EB"
        />
        <rect x="62" y="318" width="37" height="45" fill="#05AAC0" />
        <g clipPath="url(#clip7_6595_7250)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M89.6865 336.065C89.6865 340.979 85.5542 345 80.5026 345C75.4509 345 71.3186 340.979 71.3186 336.065C71.3186 331.15 75.4509 327.129 80.5026 327.129C85.5542 327.129 89.6865 331.15 89.6865 336.065ZM62.1328 357.576C62.1328 350.56 74.4165 346.985 80.5007 346.985C86.5849 346.985 98.8686 350.56 98.8686 357.576V362.871H62.1328V357.576Z"
            fill="#1D1F21"
          />
        </g>
        <rect
          x="25.8848"
          y="332.984"
          width="30.07"
          height="2.73364"
          fill="#61C9D7"
        />
        <rect
          x="25.8848"
          y="337.905"
          width="30.07"
          height="2.73364"
          fill="#61C9D7"
        />
        <rect
          x="25.8848"
          y="342.825"
          width="30.07"
          height="2.73364"
          fill="#61C9D7"
        />
        <rect
          x="25.8848"
          y="347.746"
          width="30.07"
          height="2.73364"
          fill="#61C9D7"
        />
        <rect
          x="25.8867"
          y="318.003"
          width="5.46728"
          height="5.19392"
          fill="#05AAC0"
        />
        <rect
          x="33.2656"
          y="318.003"
          width="22.6892"
          height="5.19392"
          fill="#61C9D7"
        />
        <rect
          x="25.8867"
          y="324.563"
          width="30.07"
          height="2.73364"
          fill="#61C9D7"
        />
        <rect
          x="25.8867"
          y="358.566"
          width="16.4018"
          height="4.37383"
          fill="#61C9D7"
        />
        <rect
          x="43.9277"
          y="358.566"
          width="12.028"
          height="4.37383"
          fill="#61C9D7"
        />
        <path d="M5 272H122V297H5L5 272Z" fill="#0185A2" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3741 286.674C15.6824 286.366 15.6824 285.866 15.3741 285.558C15.0658 285.25 14.5659 285.25 14.2576 285.558L11.9091 287.907C11.8952 287.919 11.8817 287.931 11.8686 287.945C11.715 288.099 11.6384 288.301 11.6387 288.503C11.6383 288.705 11.7154 288.908 11.8699 289.062C11.8831 289.075 11.8967 289.088 11.9106 289.1L14.2647 291.443C14.5738 291.751 15.0736 291.749 15.3812 291.44C15.6887 291.131 15.6875 290.631 15.3785 290.324L13.5472 288.501L15.3741 286.674Z"
          fill="white"
        />
        <g filter="url(#filter12_d_6595_7250)">
          <g clipPath="url(#clip8_6595_7250)" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M114.751 285.784C114.751 285.506 114.526 285.28 114.247 285.28H108.858C108.579 285.28 108.354 285.506 108.354 285.784C108.354 286.063 108.579 286.289 108.858 286.289H114.247C114.526 286.289 114.751 286.063 114.751 285.784ZM108.355 287.457C108.355 287.179 108.581 286.953 108.86 286.953H114.249C114.527 286.953 114.753 287.179 114.753 287.457C114.753 287.736 114.527 287.962 114.249 287.962H108.86C108.581 287.962 108.355 287.736 108.355 287.457ZM108.354 289.229C108.354 288.95 108.579 288.725 108.858 288.725H114.247C114.526 288.725 114.751 288.95 114.751 289.229C114.751 289.508 114.526 289.733 114.247 289.733H108.858C108.579 289.733 108.354 289.508 108.354 289.229Z"
          fill="white"
        />
        <path
          d="M36.8997 271.889H35.83C35.0145 271.889 34.3535 271.228 34.3535 270.413V270.229C34.3535 269.413 35.0145 268.752 35.83 268.752H90.4582C91.2736 268.752 91.9346 269.413 91.9346 270.229V270.413C91.9346 271.228 91.2736 271.889 90.4582 271.889H89.1586C88.3432 271.889 87.6821 272.55 87.6821 273.366V275.544C87.6821 278.806 85.038 281.45 81.7764 281.45H44.2819C41.0202 281.45 38.3761 278.806 38.3761 275.544V273.366C38.3761 272.55 37.7151 271.889 36.8997 271.889Z"
          fill="#393E42"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M77.5192 277.859C78.8911 277.859 80.0032 276.762 80.0032 275.408C80.0032 274.055 78.8911 272.958 77.5192 272.958C76.1473 272.958 75.0352 274.055 75.0352 275.408C75.0352 276.762 76.1473 277.859 77.5192 277.859Z"
          fill="#262C2D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M77.5193 276.94C78.3767 276.94 79.0718 276.254 79.0718 275.408C79.0718 274.563 78.3767 273.877 77.5193 273.877C76.6619 273.877 75.9668 274.563 75.9668 275.408C75.9668 276.254 76.6619 276.94 77.5193 276.94Z"
          fill="#1D1F21"
        />
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M77.5195 275.102C77.691 275.102 77.83 274.965 77.83 274.796C77.83 274.627 77.691 274.49 77.5195 274.49C77.348 274.49 77.209 274.627 77.209 274.796C77.209 274.965 77.348 275.102 77.5195 275.102Z"
          fill="#1D1F21"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.8809 275.742C55.8809 275.234 56.2923 274.823 56.7998 274.823H70.1766C70.6841 274.823 71.0955 275.234 71.0955 275.742C71.0955 276.249 70.6841 276.661 70.1766 276.661H56.7998C56.2923 276.661 55.8809 276.249 55.8809 275.742Z"
          fill="#1D1F21"
        />
      </g>
      <rect
        x="2.90448"
        y="269.785"
        width="120.477"
        height="256.015"
        rx="15.5026"
        stroke="#393E42"
        strokeWidth="4.42932"
      />
      <rect x="204" y="94" width="32" height="28" fill="#5CEBA0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M349.164 435.449C363.697 435.163 375.389 423.532 375.389 409.225C375.389 394.918 363.697 383.287 349.164 383.001L349.164 435.449Z"
        fill="#FCE969"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M349.215 383C334.682 383.286 322.99 394.917 322.99 409.224C322.99 423.531 334.682 435.163 349.215 435.448L349.215 383Z"
        fill="#E2C508"
      />
      <circle
        cx="16.7846"
        cy="16.7846"
        r="16.7846"
        transform="matrix(-1 0 0 1 366 392.311)"
        fill="#1D1F21"
      />
      <g clipPath="url(#clip9_6595_7250)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M349.577 409.841C350.031 410.333 350.631 410.609 351.222 410.609L351.239 410.594C351.316 410.594 351.393 410.586 351.47 410.579C352.296 410.473 352.791 409.905 353.157 409.485L353.174 409.465C353.199 409.436 353.227 409.404 353.255 409.371C353.396 409.206 353.569 409.005 353.611 408.973C353.613 408.975 353.616 408.977 353.62 408.98C353.633 408.989 353.655 409.007 353.688 409.042C353.774 409.142 353.851 409.242 353.92 409.349C353.927 409.36 353.935 409.371 353.943 409.382C354.074 409.567 354.223 409.776 354.434 409.972C355.162 410.632 356.138 410.725 356.986 410.21C357.423 409.941 357.808 409.557 358.194 408.988L356.729 408.19C356.481 408.558 356.241 408.804 356.018 408.942C355.864 409.042 355.813 409.05 355.65 408.904C355.581 408.842 355.517 408.751 355.447 408.653C355.421 408.617 355.395 408.58 355.367 408.543C355.256 408.382 355.136 408.228 355.007 408.082C354.682 407.721 354.279 407.506 353.834 407.467C352.806 407.383 352.207 408.074 351.813 408.535C351.633 408.75 351.376 409.05 351.23 409.065C351.196 409.065 351.059 409.019 350.913 408.858C350.571 408.481 350.262 408.005 349.963 407.529C349.826 407.314 349.594 407.176 349.32 407.145C349.046 407.114 348.781 407.206 348.592 407.383C348.01 407.944 347.316 408.504 346.674 408.428C346.451 408.397 346.211 408.328 345.971 408.213C345.993 408.186 346.016 408.159 346.04 408.132C346.063 408.105 346.087 408.078 346.108 408.051C347.059 406.891 347.556 405.493 347.496 404.118C347.419 402.282 346.245 401.053 344.566 401.053C343.367 401.053 342.459 401.553 342.014 402.467C341.123 404.264 342.245 407.145 343.367 408.274C342.793 408.612 342.168 408.881 341.543 409.127L342.22 410.532C343.059 410.202 343.907 409.833 344.678 409.319C345.26 409.68 345.843 409.887 346.442 409.956C347.487 410.079 348.369 409.626 349.012 409.142C349.183 409.38 349.372 409.618 349.577 409.841ZM343.581 403.089C343.701 402.843 343.916 402.59 344.566 402.59V402.582C345.663 402.582 345.774 403.903 345.783 404.172C345.826 405.201 345.449 406.254 344.729 407.137L344.652 407.229C343.864 406.446 343.033 404.195 343.581 403.089ZM358.194 412.202H341.543V413.795H358.194V412.202Z"
          fill="#FCE969"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6595_7250"
          x="198.441"
          y="29.8918"
          width="43.5752"
          height="70.1182"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="2.80103" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_6595_7250"
          x="170.601"
          y="57.7307"
          width="99.251"
          height="43.5747"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="2.80103" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_6595_7250"
          x="224.645"
          y="84.063"
          width="7.52097"
          height="7.59274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="0.746941" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_6595_7250"
          x="224.645"
          y="76.3896"
          width="7.52097"
          height="7.59274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="0.746941" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_6595_7250"
          x="224.645"
          y="68.7139"
          width="7.52097"
          height="7.59274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="0.746941" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_6595_7250"
          x="216.586"
          y="84.0635"
          width="7.52097"
          height="7.59274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="0.746941" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_6595_7250"
          x="216.586"
          y="76.3896"
          width="7.52097"
          height="7.59274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="0.746941" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_6595_7250"
          x="216.586"
          y="68.7139"
          width="7.52097"
          height="7.59274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="0.746941" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_6595_7250"
          x="208.528"
          y="84.0635"
          width="7.52097"
          height="7.59274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="0.746941" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d_6595_7250"
          x="208.528"
          y="76.3896"
          width="7.52097"
          height="7.59274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="0.746941" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter10_d_6595_7250"
          x="208.528"
          y="68.7139"
          width="7.52097"
          height="7.59274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="0.746941" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter11_d_6595_7250"
          x="80.7319"
          y="90.1003"
          width="273.87"
          height="367.343"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.49388" />
          <feGaussianBlur stdDeviation="2.80103" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <filter
          id="filter12_d_6595_7250"
          x="-56.7712"
          y="485.991"
          width="239.833"
          height="145.447"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.23785" />
          <feGaussianBlur stdDeviation="30.9462" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.106805 0 0 0 0 0.141746 0 0 0 0 0.182764 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6595_7250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6595_7250"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_6595_7250">
          <rect
            width="12.4651"
            height="12.4651"
            fill="white"
            transform="translate(148.027 373)"
          />
        </clipPath>
        <clipPath id="clip1_6595_7250">
          <rect
            width="12.4651"
            height="12.4651"
            fill="white"
            transform="translate(148.027 323)"
          />
        </clipPath>
        <clipPath id="clip2_6595_7250">
          <rect
            width="12.4651"
            height="12.4651"
            fill="white"
            transform="translate(148.027 348)"
          />
        </clipPath>
        <clipPath id="clip3_6595_7250">
          <rect
            width="12.4651"
            height="12.4651"
            fill="white"
            transform="translate(148.027 274)"
          />
        </clipPath>
        <clipPath id="clip4_6595_7250">
          <rect
            width="12.4651"
            height="12.4651"
            fill="white"
            transform="translate(148.027 299)"
          />
        </clipPath>
        <clipPath id="clip5_6595_7250">
          <rect
            width="70"
            height="70"
            fill="white"
            transform="translate(38 33)"
          />
        </clipPath>
        <clipPath id="clip6_6595_7250">
          <rect
            x="5.11914"
            y="272"
            width="116.048"
            height="251.585"
            rx="13.288"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip7_6595_7250">
          <rect
            width="37"
            height="36"
            fill="white"
            transform="translate(62 327)"
          />
        </clipPath>
        <clipPath id="clip8_6595_7250">
          <path
            d="M5.12109 555.929C5.12109 550.802 9.27762 546.646 14.4049 546.646H111.885C117.013 546.646 121.169 550.802 121.169 555.929V568.308H5.12109L5.12109 555.929Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip9_6595_7250">
          <rect
            width="16.6507"
            height="15.9268"
            fill="white"
            transform="translate(341.543 399.062)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HeroAsset
